module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.043774d1.woff";